import { Edit, SimpleForm } from 'react-admin';
import { SlideForm } from './SlideForm.jsx';

export const SlideEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm><SlideForm /></SimpleForm>
  </Edit>
);
